export default (theme) => ({
    list: {
        width: "100%",
        paddingTop: theme.spacing(4),
        bgcolor: theme.palette.background.lightBackground,
    },
    listSubHeader: {
        fontSize: theme.spacing(2),
        lineHeight: 1.5,
    },
    listItemBtn: {
        margin: `${theme.spacing(2)} 0 `,
        borderRadius: theme.spacing(1),
        background: theme.palette.background.mediumBackground,
    },
    wrapStepper: {
        width: "100%",
        padding: theme.spacing(4),
    },
    wrapBackBtn: {
        display: "flex",
        flexDirection: "row",
        paddingTop: theme.spacing(4),
    },
});
